import styled from 'styled-components'

const styledCardDefault = `
border-radius: 8px;
padding: 16px;
margin-bottom: 16px;

@media (min-width: 992px) {
  margin-bottom: 24px;
  padding: 24px;
  }
`

export const DescripcionAviso = styled('div')`
  ${styledCardDefault};
  background-color: ${({ theme }) => theme.colors.grey0};
  overflow-wrap: break-word;

  & > * {
    color: ${({ theme }) => theme.colors.grey84};
    font-size: 14px;
    line-height: 20px;
  }

  & > p {
    margin-top: 16px;
  }

  & > p:first-child {
    margin-top: 0;
  }

  & > p:last-child {
    margin-bottom: 0;
  }
`

export const SeparadorDetalle = styled('div')`
  height: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.grey24};
  margin-top: 16px;

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    margin-top: 24px;
  }
`

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  margin-top: 16px;
  gap: 10px;
`
